/**
 * @fileoverview Expose matter-workspace selection and queued-task refresh signals. `reducer.js` owns shared browser context; case-detail and task surfaces own requests and accepted writes. A refresh signal requests reloading rather than acknowledging remote task execution.
 */

export const SET_MATTER = 'SET_MATTER'
export const SET_REFRESH_TRELLO_TASKS = 'SET_REFRESH_TRELLO_TASKS'



export const setMatter = matter => ({ type: SET_MATTER, payload: matter });


export const setRefreshTrelloTasks = refreshTrelloTasks => ({ type: SET_REFRESH_TRELLO_TASKS, payload: refreshTrelloTasks });